import { render, staticRenderFns } from "./PlaceAlreadyClosedNotice.vue?vue&type=template&id=30ac61c9&"
import script from "./PlaceAlreadyClosedNotice.vue?vue&type=script&lang=ts&"
export * from "./PlaceAlreadyClosedNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports